export function isSafeHttpUrl(url: string | null | undefined): boolean {
  if (typeof url !== "string" || !url) return false;
  return /^https?:\/\//i.test(url.trim());
}

// Wider allowlist for local-preview sinks that intentionally render
// URL.createObjectURL() outputs (blob:) for a File the user just picked
// in this session. Never use for sinks fed by external / vendor-submitted
// data — use isSafeHttpUrl there.
export function isSafeHttpOrBlobUrl(url: string | null | undefined): boolean {
  if (typeof url !== "string" || !url) return false;
  const trimmed = url.trim();
  return /^https?:\/\//i.test(trimmed) || /^blob:/i.test(trimmed);
}
